import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ceclapiAuthLogout } from '../../store/ceclapi/actions';
import { ApplicationState } from '../../store';
import { ConfigState } from '../../store/config/types';
import { saveCookiesRequest } from '../../store/config/actions';
import { logUserOut } from '../../utils/helpers';

const Logout: React.FC = () => {
    const dispatch = useDispatch();
    const config = useSelector<ApplicationState, ConfigState>((state) => state.config);

    React.useEffect(() => {
        dispatch(ceclapiAuthLogout());
        dispatch(saveCookiesRequest({ ...config, isLoggedIn: false }));
        logUserOut();
    }, []);

    return <div>Logout</div>;
};

export default Logout;
